import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import Table from 'react-expandable-table';
import TableScrollbar from 'react-table-scrollbar';
import db from './db';
// HubUpdateTable component
export default class HubUpdateTable extends React.Component {

    // constructor
    constructor(props) {
        super(props);

        // initalize state
        this.state = {
            hubUpdates:undefined
        }
    }
    componentDidMount() {
        this.queryHubUpdate();  // wait to query hub_update table
    }
    queryHubUpdate(){
        db.getHubUpdateList(this.props.securityObject,(result)=>{
            this.setState({
                hubUpdates:result
            })
        })
    }
    // render
    render() {

        return (
            <div>
                <TableScrollbar>
                    <ErrorBoundary>
                        <Table columns={[
                                    { key: 'id', title:"id", width :10 } 
                                    , { key: 'update_description', title:"update description", width :30 }
                                    , { key: 'hardware_update', title:"hardware update", width :10 }
                                    , { key: 'corresponding_software_version', title:"corresponding software version", width :10 }
                                    , { key: 'hardware_type', title:"hardware_type", width :10 }
                                ]} 
                                dataSource={this.state.hubUpdates} 
                                />
                    </ErrorBoundary>
                </TableScrollbar>
            </div>
        );
    }
}